import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import SessionAcknowdlegement from '../components/classroom/components/configuration/SessionAcknowdlegement';
import { AppPage } from '../layouts/types';
import { updateLiveStreamSettings } from '../store/reducers/livestreamSettings';
import { RootState } from 'store';
import ChangeBackGround from '../components/classroom/components/changebackground';

const Configuration: AppPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('sessionId');
  const programId = searchParams.get('programId');

  const dispatch = useDispatch();

  useEffect(() => {
    if (sessionId) {
      dispatch(updateLiveStreamSettings({ roomId: sessionId }));
    }
  }, [dispatch, sessionId]);

  const changingBackground = useSelector(
    (state: RootState) => state.live?.settings?.backgroundEffect ?? false
  );

  const authUser = useSelector(
    (state: RootState) => state.auth?.user?.email ?? null
  );

  const bgImage = useSelector(
    (state: RootState) => state.live?.settings?.bgImage ?? {}
  );

  const pendingBg = useSelector(
    (state: RootState) => state.live?.settings?.pendingBg ?? {}
  );

  useEffect(() => {
    dispatch(updateLiveStreamSettings({ bgImage: {...bgImage, [authUser]: '' } }))
  }, []);

  const removeBackground = () => {
    // @ts-ignore
    dispatch(updateLiveStreamSettings({ backgroundEffect: false }));
  };

  const applyBackgroundEffect = (imageUrl: any) => {
   dispatch(updateLiveStreamSettings({ pendingBg: {...pendingBg, [authUser]: imageUrl } }))
  };

  return (
    <>
      <div className="flex-1">
        <div
          className="flex justify-center items-center min-h-screen bg-transparent"
          style={{
            backgroundImage: `url('/img/joinSessionBackground.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <SessionAcknowdlegement
            sessionId={sessionId as string}
            programId={programId as string}
          />
        </div>
      </div>

      {changingBackground && (
        <ChangeBackGround
          closePopup={removeBackground}
          applyBackgroundEffect={applyBackgroundEffect}
        />
      )}
    </>
  );
};

export default Configuration;
